import { Button } from "@/components/ui/button";
import { Lock, ExternalLink } from "lucide-react";

export const AccessDenied = () => (
  <div className="min-h-screen flex flex-col items-center justify-center gap-6 p-6 bg-background">
    <div className="text-center max-w-md">
      <div className="mx-auto mb-5 w-14 h-14 rounded-full bg-muted flex items-center justify-center">
        <Lock className="h-7 w-7 text-primary" aria-hidden="true" />
      </div>
      <h1 className="font-display text-2xl font-semibold text-foreground mb-3 tracking-tight">
        Outlook required
      </h1>
      <p className="text-base text-muted-foreground mb-6 leading-relaxed">
        email2contact runs as an add-in inside Microsoft Outlook.
        Install it once, then open any email to extract contacts.
      </p>
      <div className="flex flex-col gap-2">
        <Button asChild className="shadow-fluent-2">
          <a
            href="https://appsource.microsoft.com/en-us/product/office/WA200008934"
            target="_blank"
            rel="noopener noreferrer"
          >
            <ExternalLink className="h-4 w-4 mr-2" aria-hidden="true" />
            Get on Microsoft AppSource
          </a>
        </Button>
        <Button asChild variant="ghost" size="sm">
          <a href="/">Visit homepage</a>
        </Button>
      </div>
    </div>
  </div>
);
